<template>
  <v-card flat color="transparent">
    <v-card-title class="pa-0 mb-4 d-block">
      <h4 class="text-h5 font-weight-bold white--text">Gastos por categoría</h4>
      <div class="blue-grey--text text--lighten-2 text-caption">
        Analizá tus categorías y gasto mensual para controlar tus finanzas.
      </div>
    </v-card-title>

    <v-row justify="center" align="center">
      <v-col cols="12" md="5" class="text-center position-relative">
        <doughnut-chart
          v-if="chartGastos"
          :chartdata="chartGastos"
          :key="keyChartGastos"
          :options="chartOptions"
        />
        <div class="mt-4">
          <div class="caption blue-grey--text text--lighten-3 text-uppercase font-weight-bold">Total Acumulado</div>
          <div class="text-h4 font-weight-black primary--text">
            {{ totalGastosPorCategoria | convertPesoArg }}
          </div>
        </div>
      </v-col>

      <v-col cols="12" md="7">
        <v-list v-if="chartGastos && verListadoGastos" color="transparent" class="pa-0">
          <v-list-item
            v-for="gasto in chartGastos.data"
            :key="gasto.id"
            class="px-0 mb-1 list-item-custom"
            @click="$router.push({ name: 'empresa.gastos.detalle', params: { categoria: gasto } })"
          >
            <v-list-item-avatar size="12" class="mr-3">
              <v-sheet :color="gasto.color" rounded="circle" height="12" width="12"></v-sheet>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title class="white--text font-weight-medium">
                {{ gasto.name }}
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action class="white--text font-weight-bold">
              {{ gasto.total_categoria | convertPesoArg }}
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>

    <v-divider dark class="my-4" style="opacity: 0.1"></v-divider>
    
    <v-list-item 
      @click="$router.push({ name: 'empresa.gastos.detalle' })"
      class="px-0"
    >
      <v-list-item-content>
        <v-list-item-title class="primary--text font-weight-bold">
          Analizar todos los gastos
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-icon color="primary">mdi-arrow-right</v-icon>
      </v-list-item-action>
    </v-list-item>
  </v-card>
</template>

<script>
import DoughnutChart from "@/chartjs/doughnut.chart.vue";

export default {
  name: "ChartGastosPorMes",
  components: { DoughnutChart },
  props: {
    chartGastos: { required: true },
    verListadoGastos: { type: Boolean, default: true },
    verAction: { type: Boolean, default: false },
  },
  computed: {
    totalGastosPorCategoria() {
      if (!this.chartGastos?.data) return 0;
      return this.chartGastos.data.reduce((acc, obj) => acc + obj.total_categoria, 0);
    },
  },
  data() {
    return {
      keyChartGastos: 1,
      chartOptions: {
        cutoutPercentage: 70, // Hace el centro más grande para que parezca un anillo moderno
        legend: { display: false },
        maintainAspectRatio: false,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.list-item-custom {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  transition: background 0.2s;
  &:hover {
    background: rgba(255, 255, 255, 0.03);
  }
}
</style>